module.exports = __webpack_public_path__ + "img/Menu-08.983796ce.png";